<template>
    <tr v-bind:class="{'d-none': !showRow}">
        <td>
            <div class="d-flex align-items-center">
                <div v-if="item.children && item.children.length">
                    <span class="cursor-pointer collapsible rotate" v-bind:class="{collapsed: !openedExpandRow(itemIndex)}" v-on:click="handleExpandRow(itemIndex)">
                        <div class="me-3 rotate-90">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/media/icons/duotune/arrows/arr071.svg"/>
                            </span>
                        </div>
                    </span>
                </div>
                <div v-else-if="depth != 0" class="row-indent" v-bind:style="{'padding-left': (depth * 5)+ 'px', 'margin-top': '-8px'}">
                    <span class="svg-icon svg-icon-4 me-2">
                        <inline-svg src="/media/icons/duotune/arrows/arr049.svg" />
                    </span>
                    <span v-bind:style="{'padding-left': (depth * 5)+ 'px'}"></span>
                </div>
                <div>
                    <label class="w-150px">{{ item.title }}</label>
                </div>
            </div>
        </td>
        <td>{{ (item.schedule ? (sprintf('%s (%s - %s)', [item.schedule.date, item.schedule.start_time, item.schedule.end_time])) : "-")}}</td>
        <td>{{ item.quantity }}</td>
        <td>{{ item.total + ' ' + currency.suffix }}</td>
    </tr>
    <TreeCourse
        v-for="(child, childIndex) in item.children"
        :item="child"
        :itemIndex="childIndex"
        :key="childIndex"
        :depth="depth + 1"
        :currency="currency"
        :showRow="openedExpandRow(itemIndex) && showRow"
    ></TreeCourse>
</template>

<script>
import TreeCourse from '@/components/ecommerce/order/detail/treeCourse.vue';

export default {
    name: "treeProduct",
    props: ['item', 'itemIndex', 'depth', 'currency', 'showRow'],
    components: {
        TreeCourse
    },
    data() {
        return {
            expandRow: {
                closed: []
            }
        }
    },
    methods: {
        openedExpandRow(index) {
            return !this.expandRow.closed.includes(index);
        },
        handleExpandRow(itemIndex) {
            let x = this.expandRow.closed.indexOf(itemIndex);
            if(x !== -1) {
                this.expandRow.closed.splice(x, 1);
            } else {
                this.expandRow.closed.push(itemIndex);
            }
        }
    }
}
</script>

<style>
    .editUsageDateButton{
        padding: 6px 9px;
        min-height: unset !important;
    }
</style>